import { useTexts } from 'utils/useTexts';
import useEffectOnce from '@shared/hooks/useEffectOnce';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { SEGMENT_SCREEN_PARAMS } from '@shared/constants/segmentConstants';

const DisqualifiedDefaultCreditScore = () => {
  const { t } = useTexts();
  const { trackClick, trackPage } = useAnalytics(SEGMENT_SCREEN_PARAMS.OFFER_OFF_RAMP ,false);

  useEffectOnce(() => trackPage(t('pageTitles.DeclineCredit') + '- softpull failed, default credit Score used',{
    off_ramp_variant: 'call_us',
    trigger_reason: 'no_offers',
  }));

  const handlePhoneNumberClick = () => {
    trackClick('CTA Clicked', {
      cta_text: 'Call'+t('contactPhoneNumber'),
      cta_type: 'phone',
      cta_context: 'off-ramp',
      interaction_type: 'cta_click',
      destination_url: 'tel:'+t('contactPhoneNumber'),
      value: 75,
      currency: 'USD',
    });
  };

  return (
    <div className="iLendingCDX-disqualified-container">
      <h1 className="iLendingCDX-form-title iLendingCDX-mb-8">{t('disqualifiedDefaultCreditScore.title')}</h1>
      <p className="iLendingCDX-mb-4">{t('disqualifiedDefaultCreditScore.startText')}</p>
      <p className="iLendingCDX-mb-4">{t('disqualifiedDefaultCreditScore.midText')}</p>

      <p className="iLendingCDX-mb-4">
        {t('disqualifiedDefaultCreditScore.endText')}
        <a
          href={'tel:' + t('contactPhoneNumber').replace(/-/g, '')}
          onClick={handlePhoneNumberClick}
        >
          {t('contactPhoneNumber')}
        </a>
        {t('disqualifiedDefaultCreditScore.weareHappyToAssist')}
      </p>
    </div>
  );
};

export default DisqualifiedDefaultCreditScore;
